import { CHLastLoad } from './sessions'
import { sessionId } from 'pubsub/events'
import { TealiumEvent } from './tealium'
import { CoreEvent } from './core'

export interface EventPublisher {
  subscribe: (config: SubscribeConfig) => Subscriber
  publish: (event: Event) => void
}

export interface Event {
  sessionId?: string
  /** Data to send to tealium */
  tealium?: TealiumEvent
  /** Data for core */
  core?: CoreEvent
}

export interface Subscriber {
  next: (event: Event) => void;
  unsubscribe: () => void;
}

interface SubscribeConfig {
  next: (event: Event) => void;
}

export const createEventPublisher = (): EventPublisher => {
  const events: Event[] = []
  const subscribers: Subscriber[] = []

  function publish (event: Event) {
    const eventWithSessionId: Event = { ...event, sessionId }
    events.push(eventWithSessionId)
    localStorage.setItem(CHLastLoad, new Date().toDateString())

    subscribers.forEach((subscriber) => {
      subscriber.next(eventWithSessionId)
    })
  }

  function subscribe (config: SubscribeConfig) {
    const subscription: Subscriber = {
      next: config.next,
      unsubscribe: () => {
        const subscriptionIndex = subscribers.indexOf(subscription)
        subscribers.splice(subscriptionIndex, 1)
      }
    }

    subscribers.push(subscription)

    return subscription
  }

  return {
    publish,
    subscribe
  }
}

export default createEventPublisher()
